import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        name: {
            component: LinkTitleComponent,
        }
    },
    sortable: [],
    filterable: [],
    toolbarDisabled: true,
    toolbar: ['create'],
    pagination: true,
    searchable: false,
    treeView: false,
    actions: [
        {
            name: 'edit',
            primary: true,
            component: 'edit-button',
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            component: 'delete-button',
            primary: true,
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.page-page_tabs.js